"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7275],{

/***/ 35905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MENU_OPTIONS": function() { return /* binding */ MENU_OPTIONS; },
  "OWNER_OPTIONS": function() { return /* binding */ OWNER_OPTIONS; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/source/source-collapsed/SourceCollapsed.tsx + 2 modules
var SourceCollapsed = __webpack_require__(85611);
// EXTERNAL MODULE: ./src/components/source/source-preview/SourcePreview.tsx + 2 modules
var SourcePreview = __webpack_require__(34549);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/components/chips/Chip.tsx
var Chip = __webpack_require__(34001);
// EXTERNAL MODULE: ./src/utils/StringUtils.tsx
var StringUtils = __webpack_require__(94030);
;// CONCATENATED MODULE: ./src/page-components/search/components/HashtagSearchedResultMobile.tsx







var HashtagSearchedResultDesktop = function(param) {
    var searchedHashtag = param.searchedHashtag;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var _sources;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDir: "column",
        align: "flex-start",
        mb: global/* BLOCK_WIDTH_REM */.sC,
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                alignItems: "center",
                gridGap: esm.spacing.M.rem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        content: "#" + searchedHashtag.name,
                        href: "topic/".concat(searchedHashtag.name),
                        m: "0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, {
                        fontSize: "0.8em",
                        color: esm.color[colorMode].textDisabled,
                        children: [
                            (0,global/* numberFormatter */.V2)(searchedHashtag.totalIdeas),
                            " ",
                            (0,StringUtils/* getSingularOrPlural */.Lo)(searchedHashtag.totalIdeas, "idea", "ideas")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                mt: global/* GAP_SIZE_REM */.L3,
                gridGap: global/* GAP_SIZE_REM */.L3,
                width: "100%",
                overflow: {
                    base: "scroll",
                    md: "hidden"
                },
                children: ((_sources = searchedHashtag.sources) !== null && _sources !== void 0 ? _sources : []).slice(0, 4).map(function(source) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                        size: "small",
                        source: source
                    }, source.id);
                })
            })
        ]
    });
};
/* harmony default export */ var HashtagSearchedResultMobile = (HashtagSearchedResultDesktop);

// EXTERNAL MODULE: ./src/components/navigation/NextLink.tsx
var NextLink = __webpack_require__(50752);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./src/components/social/ProfilePicture.tsx
var ProfilePicture = __webpack_require__(7877);
// EXTERNAL MODULE: ./src/components/buttons/FollowUserButton.tsx + 1 modules
var FollowUserButton = __webpack_require__(97360);
;// CONCATENATED MODULE: ./src/page-components/search/components/UserInfo.tsx








var UserInfo = function(param) {
    var user = param.user, index = param.index;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var profile = (0,useProfile/* default */.Z)().profile;
    var _bio;
    var bioFragments = (0,react.useMemo)(function() {
        return (0,StringUtils/* fragmentTextWithEmojis */.CO)((_bio = user.bio) !== null && _bio !== void 0 ? _bio : "");
    }, [
        user
    ]);
    if (!user) return null;
    var _photo;
    var displayUser = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        _focus: undefined,
        _active: undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePicture/* default */.Z, {
                m: esm.spacing.toRem(2),
                photo: (_photo = user.photo) !== null && _photo !== void 0 ? _photo : "",
                size: "l",
                imageBlurhash: user.photo_blurhash
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                ml: "8px",
                flexDir: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                        fontSize: "16px",
                        lineHeight: "19px",
                        fontWeight: "bold",
                        color: esm.color[colorMode].primary,
                        _hover: {
                            textDecoration: "underline"
                        },
                        textOverflow: "ellipsis",
                        noOfLines: 1,
                        children: "@" + user.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                        color: esm.color[colorMode].textSecondary,
                        textOverflow: "ellipsis",
                        noOfLines: 1,
                        children: !!user.firstName || !!user.lastName ? "".concat(user.firstName, " ").concat(user.lastName) : user.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                        textAlign: "center",
                        w: "100%",
                        children: bioFragments.map(function(fragment) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                size: "s",
                                color: esm.color[colorMode].textDisabled,
                                textOverflow: "ellipsis",
                                noOfLines: 1,
                                children: fragment
                            }, fragment);
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
        bgColor: esm.color[colorMode].top,
        p: esm.spacing.toRem(16),
        borderRadius: esm.spacing.toRem(20),
        mb: esm.spacing.toRem(12),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            justifyContent: "space-between",
            alignItems: "start",
            _focus: undefined,
            _active: undefined,
            wordBreak: "break-all",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: "/u/".concat(user.username),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                        w: "100%",
                        _focus: undefined,
                        _active: undefined,
                        _hover: undefined,
                        children: displayUser
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowUserButton/* default */.Z, {
                    display: (profile === null || profile === void 0 ? void 0 : profile.id) === user.id ? "none" : "inline-flex",
                    userId: user.id,
                    size: "sm",
                    px: esm.spacing.toRem(12),
                    py: esm.spacing.toRem(6)
                })
            ]
        })
    }, index);
};
/* harmony default export */ var components_UserInfo = (UserInfo);

;// CONCATENATED MODULE: ./src/page-components/search/SearchPage.tsx









var SearchPageMobile = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9283).then(__webpack_require__.bind(__webpack_require__, 19283));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19283)
            ];
        }
    }
});
var SearchPageDesktop = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9891), __webpack_require__.e(9834), __webpack_require__.e(2853), __webpack_require__.e(1425), __webpack_require__.e(7436)]).then(__webpack_require__.bind(__webpack_require__, 16171));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16171)
            ];
        }
    }
});
SearchPageDesktop.displayName = "SearchPageDesktop";
SearchPageMobile.displayName = "SearchPageMobile";
var SearchPage = function(param) {
    var initialApiData = param.initialApiData, initialSearchType = param.initialSearchType;
    var isMobileView = (0,esm.useIsMobileView)();
    /**
   * Render the search results
   * @param feed The results to be rendered
   * @param isFetching Whether or not we are currently fetching more results
   * @param searchType What we are searching for
   * @param errorMessage A component to be shown if no results were found
   */ var renderFeed = (0,react.useCallback)(function(feed, isFetching, searchType, errorMessage) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(esm.Box, {
            children: !isFetching && (!feed || feed.length === 0) ? errorMessage : /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                children: [
                    searchType === "article" && feed.map(function(source) {
                        if ((0,global/* isSourceEmpty */.dq)(source)) return null;
                        if (searchType === "article") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                                    source: source,
                                    mb: esm.spacing.XXXL.rem
                                })
                            }, "articleCard$".concat(source.id));
                        }
                        return null;
                    }),
                    searchType === "block" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                        flexDir: "column",
                        width: "100%",
                        alignItems: "center",
                        children: feed === null || feed === void 0 ? void 0 : feed.map(function(idea) {
                            var source = idea.source;
                            if (!source || (0,global/* isSourceEmpty */.dq)(source)) return null;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourcePreview/* default */.Z, {
                                    source: source,
                                    ideaId: idea.id,
                                    mb: esm.spacing.XXXL.rem
                                })
                            }, source.id);
                        })
                    }),
                    searchType === "user" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        px: {
                            base: "1rem",
                            lg: 0
                        },
                        children: feed.map(function(user, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                                user: user,
                                index: index
                            }, user.id);
                        })
                    }),
                    searchType === "hashtag" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        px: {
                            base: "1rem",
                            lg: 0
                        },
                        children: feed.map(function(searchedHashtag, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HashtagSearchedResultMobile, {
                                searchedHashtag: searchedHashtag
                            }, "SearchHashtagSection-".concat(searchedHashtag.name, "-").concat(index));
                        })
                    })
                ]
            })
        });
    }, []);
    return isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPageMobile, {
        initialSearchType: initialSearchType,
        renderFeed: renderFeed,
        initialApiData: initialApiData
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPageDesktop, {
        initialSearchType: initialSearchType,
        renderFeed: renderFeed,
        initialApiData: initialApiData
    });
};
/* harmony default export */ var search_SearchPage = (SearchPage);

;// CONCATENATED MODULE: ./pages/search.tsx



var MENU_OPTIONS = [
    {
        title: "Ideas",
        key: "block"
    },
    {
        title: "People",
        key: "user"
    },
    {
        title: "Topics",
        key: "hashtag"
    },
    {
        title: "Sources",
        key: "article"
    }, 
];
var OWNER_OPTIONS = [
    {
        title: "All",
        key: "all"
    },
    {
        title: "Own",
        key: "own"
    }, 
];
var Search = function(param) {
    var initialApiData = param.initialApiData, initialSearchType = param.initialSearchType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(search_SearchPage, {
        initialApiData: initialApiData !== null && initialApiData !== void 0 ? initialApiData : undefined,
        initialSearchType: initialSearchType !== null && initialSearchType !== void 0 ? initialSearchType : undefined
    });
};
// export const getServerSideProps: GetServerSideProps<OwnProps> = async ctx => {
//   const { q, owner, tab } = ctx.query;
//   const { token } = cookie.parse(ctx.req.headers.cookie ?? '');
//   if (!q) {
//     return {
//       props: {
//         initialApiData: null,
//         initialSearchType: null,
//       },
//     };
//   }
//   //Get rid of the # in the query
//   let parsedSearchText = q as string;
//   if (parsedSearchText.includes('#')) {
//     parsedSearchText = replaceAll(parsedSearchText, '#', '');
//   }
//   //Get the search type based on the query param
//   const searchType =
//     MENU_OPTIONS.find(
//       option => option.title.toLowerCase() === (tab as SearchType),
//     )?.key ?? 'block';
//   const res = await search(
//     parsedSearchText,
//     searchType,
//     owner as 'all' | 'own',
//     token,
//   );
//   return {
//     props: {
//       initialApiData: res ?? null,
//       initialSearchType: searchType,
//     },
//   };
// };
/* harmony default export */ var search = (Search);


/***/ }),

/***/ 12973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dq": function() { return /* binding */ SOURCES_TYPE_ID_TYPE_PREFIX; },
/* harmony export */   "ji": function() { return /* binding */ HIGHLIGHTS_ID_PREFIX; },
/* harmony export */   "lO": function() { return /* binding */ HASHTAG_ID_TYPE_PREFIX; },
/* harmony export */   "mF": function() { return /* binding */ DAILY_PICKS_ID; }
/* harmony export */ });
var HIGHLIGHTS_ID_PREFIX = "highlight-";
// The prefixes of the section items ids
// Used to determine the type of the section item
var HASHTAG_ID_TYPE_PREFIX = "hashtag-";
var SOURCES_TYPE_ID_TYPE_PREFIX = "sources-by-type-";
var DAILY_PICKS_ID = "daily-picks";


/***/ }),

/***/ 90352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AI": function() { return /* binding */ getInitialSectionFromExploreDestinationPath; },
/* harmony export */   "EV": function() { return /* binding */ getHashtagNameFromSectionItemId; },
/* harmony export */   "Ih": function() { return /* binding */ getSourceTypeIllustration; },
/* harmony export */   "JI": function() { return /* binding */ DAILY_PICKS_ID_PREFIX; },
/* harmony export */   "Jq": function() { return /* binding */ getExploreSectionItemIllustration; },
/* harmony export */   "KF": function() { return /* binding */ shouldIgnoreExploreItem; },
/* harmony export */   "SM": function() { return /* binding */ getExploreSectionItemType; },
/* harmony export */   "Yx": function() { return /* binding */ getExploreSectionItemLink; }
/* harmony export */ });
/* unused harmony exports isExplorePageSourceType, isExplorePageType */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3620);
/* harmony import */ var utils_metatopics_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90031);
/* harmony import */ var utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12973);




//TODO: Move to constants
var DAILY_PICKS_ID_PREFIX = "explore-daily-";
var getExploreSectionItemIllustration = function(param) {
    var id = param.id, type = param.type;
    switch(type){
        case "highlight-hashtag":
            {
                var ref;
                // Remove the highlight prefix to match the hashtag id
                var hashtagId = id.substr(utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__/* .HIGHLIGHTS_ID_PREFIX.length */ .ji.length);
                var ref1;
                return (ref1 = (ref = utils_metatopics_constants__WEBPACK_IMPORTED_MODULE_1__/* .METATOPICS.find */ .zY.find(function(topic) {
                    return topic.exploreId === hashtagId;
                })) === null || ref === void 0 ? void 0 : ref.image) !== null && ref1 !== void 0 ? ref1 : "";
            }
        case "hashtag":
            {
                var ref2;
                var ref3;
                return (ref3 = (ref2 = utils_metatopics_constants__WEBPACK_IMPORTED_MODULE_1__/* .METATOPICS.find */ .zY.find(function(topic) {
                    return topic.exploreId === id;
                })) === null || ref2 === void 0 ? void 0 : ref2.image) !== null && ref3 !== void 0 ? ref3 : "";
            }
        case "source_type":
            {
                var sourceType = id.substr(utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOURCES_TYPE_ID_TYPE_PREFIX.length */ .Dq.length);
                return "https://static.deepstash.com/illustrations/categories/".concat(sourceType, ".svg");
            }
        case "daily-pick":
            {
                return "https://static.deepstash.com/illustrations/categories/daily_picks.svg";
            }
        default:
            {
                return "";
            }
    }
};
/**
 * Get the type of an explore section item based on its id
 */ var getExploreSectionItemType = function(id) {
    if (id === utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__/* .DAILY_PICKS_ID */ .mF) {
        return "daily-pick";
    } else if (id.includes(utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__/* .HIGHLIGHTS_ID_PREFIX */ .ji)) {
        if (id.includes(utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__/* .HASHTAG_ID_TYPE_PREFIX */ .lO)) {
            return "highlight-hashtag";
        }
    } else if (id.includes(utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__/* .HASHTAG_ID_TYPE_PREFIX */ .lO)) {
        return "hashtag";
    } else if (id.includes(utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOURCES_TYPE_ID_TYPE_PREFIX */ .Dq)) {
        return "source_type";
    }
    return "not-implemented";
};
var getHashtagNameFromSectionItemId = function(id) {
    if (id.includes(utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__/* .HIGHLIGHTS_ID_PREFIX */ .ji)) {
        return id.substring(utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__/* .HASHTAG_ID_TYPE_PREFIX.length */ .lO.length + utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__/* .HIGHLIGHTS_ID_PREFIX.length */ .ji.length);
    } else {
        return id.substring(utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__/* .HASHTAG_ID_TYPE_PREFIX.length */ .lO.length);
    }
};
var getInitialSectionFromExploreDestinationPath = function(destinationPath) {
    var ref;
    // Get the query params from the string
    var queryParams = ((ref = destinationPath.split("?")[1]) !== null && ref !== void 0 ? ref : "").split("&").reduce(function(acc, keyValueString) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(keyValueString.split("="), 2), key = ref[0], value = ref[1];
        acc[key] = value;
        return acc;
    }, {});
    return queryParams["initial_section"];
};
var getExploreSectionItemLink = function(exploreSectionItem) {
    switch(exploreSectionItem.type){
        case "daily-pick":
            {
                return "/explore/daily-picks";
            }
        case "hashtag":
            {
                if ((0,types__WEBPACK_IMPORTED_MODULE_0__/* .isExploreSectionHashtagItem */ .WO)(exploreSectionItem)) {
                    return "/topic/".concat(exploreSectionItem.hashtagName);
                } else {
                    // Can't navigate to the topic page
                    return undefined;
                }
            }
        case "highlight-hashtag":
            {
                if ((0,types__WEBPACK_IMPORTED_MODULE_0__/* .isExploreSectionHashtagHighlightItem */ .cG)(exploreSectionItem)) {
                    return "/topic/".concat(exploreSectionItem.hashtagName, "/?initial_section=").concat(exploreSectionItem.initialSection);
                } else {
                    // Can't navigate to the topic page
                    return undefined;
                }
            }
        case "source_type":
            {
                if (exploreSectionItem.id === "sources-by-type-collections") {
                    return "/all-collections";
                }
                return "/explore/sources/page/".concat(exploreSectionItem.id.substring(utils_explore_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOURCES_TYPE_ID_TYPE_PREFIX.length */ .Dq.length));
            }
        default:
            {
                return undefined;
            }
    }
};
var shouldIgnoreExploreItem = function(item) {
    // We ignore highlight cards
    if (item.type === "highlight-hashtag") {
        return true;
    }
    return false;
};
var getSourceTypeIllustration = function(sourceType) {
    switch(sourceType){
        case types__WEBPACK_IMPORTED_MODULE_0__/* .SourceType.ARTICLE */ .PO.ARTICLE:
            {
                return "https://static.deepstash.com/illustrations/categories/articles.svg";
            }
        case types__WEBPACK_IMPORTED_MODULE_0__/* .SourceType.BOOK */ .PO.BOOK:
            {
                return "https://static.deepstash.com/illustrations/categories/books.svg";
            }
        case types__WEBPACK_IMPORTED_MODULE_0__/* .SourceType.PODCAST */ .PO.PODCAST:
            {
                return "https://static.deepstash.com/illustrations/categories/podcasts.svg";
            }
        case types__WEBPACK_IMPORTED_MODULE_0__/* .SourceType.VIDEO */ .PO.VIDEO:
            {
                return "https://static.deepstash.com/illustrations/categories/videos.svg";
            }
        case 6:
        default:
            {
                return "https://static.deepstash.com/illustrations/categories/collections.svg";
            }
    }
};
function isExplorePageSourceType(param) {
    return param === "articles" || param === "books" || param === "videos" || param === "podcasts";
}
function isExplorePageType(param) {
    return param === "read_next" || param === "top_stashers" || param === "popular" || param === "newest" || param === "page";
}


/***/ }),

/***/ 56348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fn": function() { return /* binding */ normalizeExploreApiResponse; },
/* harmony export */   "qj": function() { return /* binding */ normalizeExploreSourceTypeApiResponse; },
/* harmony export */   "rJ": function() { return /* binding */ normalizeDailyPicksApiResponse; }
/* harmony export */ });
/* unused harmony exports normalizeExploreSectionItemApiResponse, normalizeExploreSectionApiResponse, mutateExploreResponse, normalizeExploreSourceTypeSectionApiResponse */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var api_api_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83675);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3620);
/* harmony import */ var utils_explore_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90352);
/* harmony import */ var utils_normalizers_source__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27079);
/* harmony import */ var utils_normalizers_profile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7269);
/* harmony import */ var utils_source_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15959);
/* harmony import */ var utils_explore_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12973);









var normalizeExploreSectionItemApiResponse = function(res) {
    var sectionType = (0,utils_explore_utils__WEBPACK_IMPORTED_MODULE_1__/* .getExploreSectionItemType */ .SM)(res.id);
    // The API sends `sources-by-type-article` instead of `sources-by-type-articles` as the id for the articles categ
    // Change it there in the normalization so that the components in the page can expect that the source type is always plural
    var correctedId = res.id;
    if (correctedId === "".concat(utils_explore_constants__WEBPACK_IMPORTED_MODULE_4__/* .SOURCES_TYPE_ID_TYPE_PREFIX */ .Dq, "article")) {
        correctedId = "".concat(utils_explore_constants__WEBPACK_IMPORTED_MODULE_4__/* .SOURCES_TYPE_ID_TYPE_PREFIX */ .Dq, "articles");
    }
    var _subtitle;
    var exploreBasicSection = {
        id: correctedId,
        title: res.title,
        subtitle: (_subtitle = res.subtitle) !== null && _subtitle !== void 0 ? _subtitle : undefined,
        illustration: (0,utils_explore_utils__WEBPACK_IMPORTED_MODULE_1__/* .getExploreSectionItemIllustration */ .Jq)({
            id: correctedId,
            type: sectionType
        }),
        type: sectionType
    };
    if (sectionType === "hashtag") {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, exploreBasicSection), {
            hashtagName: (0,utils_explore_utils__WEBPACK_IMPORTED_MODULE_1__/* .getHashtagNameFromSectionItemId */ .EV)(exploreBasicSection.id)
        });
    } else if (sectionType === "highlight-hashtag") {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, exploreBasicSection), {
            hashtagName: (0,utils_explore_utils__WEBPACK_IMPORTED_MODULE_1__/* .getHashtagNameFromSectionItemId */ .EV)(exploreBasicSection.id),
            initialSection: (0,utils_explore_utils__WEBPACK_IMPORTED_MODULE_1__/* .getInitialSectionFromExploreDestinationPath */ .AI)(res.destination_path)
        });
    }
    return exploreBasicSection;
};
var normalizeExploreSectionApiResponse = function(res) {
    return {
        id: res.id,
        title: res.title,
        items: res.objects.map(function(el) {
            return normalizeExploreSectionItemApiResponse(el);
        })
    };
};
var normalizeExploreApiResponse = function(res) {
    return mutateExploreResponse(res).objects.map(function(el) {
        return normalizeExploreSectionApiResponse(el);
    });
};
var mutateExploreResponse = function(exploreApiResponse) {
    var ref, ref1;
    var ref2;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, exploreApiResponse), {
        objects: [
            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, exploreApiResponse.objects[0]), {
                objects: (ref = exploreApiResponse.objects[0]) === null || ref === void 0 ? void 0 : ref.objects.concat((ref2 = (ref1 = exploreApiResponse.objects[1]) === null || ref1 === void 0 ? void 0 : ref1.objects) !== null && ref2 !== void 0 ? ref2 : [])
            }),
            exploreApiResponse.objects[2], 
        ]
    });
};
var normalizeExploreSourceTypeSectionApiResponse = function(res) {
    var ref;
    var normalizedObjects = [];
    var itemType = (ref = res.objects[0]) === null || ref === void 0 ? void 0 : ref._object_type;
    if (itemType === "article") {
        normalizedObjects = res.objects// Keep only the articles
        // This filtering is done as type check. If the above if is true, all items should be articles
        .filter(function(obj) {
            return (0,api_api_types__WEBPACK_IMPORTED_MODULE_7__/* .isExploreSourceTypeSectionSourceItemApiResponse */ .fi)(obj);
        }).map(function(obj) {
            return (0,utils_normalizers_source__WEBPACK_IMPORTED_MODULE_2__/* .normalizeSource */ .Nr)(obj);
        });
    } else if (itemType === "user") {
        normalizedObjects = res.objects// Keep only the users
        // This filtering is done as type check. If the above if is true, all items should be users
        .filter(function(obj) {
            return (0,api_api_types__WEBPACK_IMPORTED_MODULE_7__/* .isExploreSourceTypeSectionUserItemApiResponse */ .ib)(obj);
        }).map(function(obj) {
            return (0,utils_normalizers_profile__WEBPACK_IMPORTED_MODULE_8__/* .normalizeUserData */ .Te)(obj);
        });
    }
    // Trim the /api/v2 prefix
    var normalizedLink = res.link.substring(7);
    // Now get the source type from the end and turn it from singular to plural
    var linkTokens = normalizedLink.split("/");
    // The last token is an empty string since there is a trailing /, so the source type is the one before
    linkTokens[linkTokens.length - 2] = (0,utils_source_utils__WEBPACK_IMPORTED_MODULE_3__/* .getSourceTypePlural */ .ZQ)(linkTokens[linkTokens.length - 2]);
    normalizedLink = linkTokens.join("/");
    return {
        id: res.id,
        itemType: itemType,
        name: res.name,
        link: normalizedLink,
        items: normalizedObjects
    };
};
var normalizeExploreSourceTypeApiResponse = function(res) {
    return {
        ideaCount: res.total_ideas,
        sections: res.objects.map(function(el) {
            return normalizeExploreSourceTypeSectionApiResponse(el);
        })
    };
};
var normalizeDailyPicksApiResponse = function(res) {
    return res.objects.map(function(sectionObject) {
        var ref;
        var sectionType;
        switch(sectionObject.id.substring(utils_explore_utils__WEBPACK_IMPORTED_MODULE_1__/* .DAILY_PICKS_ID_PREFIX.length */ .JI.length)){
            case "botd":
                {
                    sectionType = types__WEBPACK_IMPORTED_MODULE_0__/* .DailyPicksSectionType.BOOK_OF_THE_DAY */ .Zo.BOOK_OF_THE_DAY;
                    break;
                }
            case "botd-history":
                {
                    sectionType = types__WEBPACK_IMPORTED_MODULE_0__/* .DailyPicksSectionType.BOOK_OF_THE_DAY_HISTORY */ .Zo.BOOK_OF_THE_DAY_HISTORY;
                    break;
                }
            case "qotd":
                {
                    sectionType = types__WEBPACK_IMPORTED_MODULE_0__/* .DailyPicksSectionType.QUOTE_OF_THE_DAY */ .Zo.QUOTE_OF_THE_DAY;
                    break;
                }
            case "qotd-history":
                {
                    sectionType = types__WEBPACK_IMPORTED_MODULE_0__/* .DailyPicksSectionType.QUOTE_OF_THE_DAY_HISTORY */ .Zo.QUOTE_OF_THE_DAY_HISTORY;
                    break;
                }
            case "todays-pick":
                {
                    sectionType = types__WEBPACK_IMPORTED_MODULE_0__/* .DailyPicksSectionType.PICKS */ .Zo.PICKS;
                    break;
                }
            case "previous-picks":
                {
                    sectionType = types__WEBPACK_IMPORTED_MODULE_0__/* .DailyPicksSectionType.PICKS_HISTORY */ .Zo.PICKS_HISTORY;
                    break;
                }
            default:
                {
                    throw Error("Unsupported daily pick section");
                }
        }
        return {
            id: sectionObject.id,
            name: sectionObject.name,
            // Remove /api/v2
            // The page link is with - instead of _
            link: (ref = sectionObject.link) === null || ref === void 0 ? void 0 : ref.substring(7).replace("daily_picks", "daily-picks"),
            sectionType: sectionType,
            itemType: sectionObject.objects[0].object._object_type,
            items: sectionObject.objects[0].object._object_type === "article" ? sectionObject.objects.map(function(param) {
                var object = param.object;
                return (0,utils_normalizers_source__WEBPACK_IMPORTED_MODULE_2__/* .normalizeSource */ .Nr)(object);
            }) : sectionObject.objects.map(function(param) {
                var object = param.object;
                return (0,utils_normalizers_source__WEBPACK_IMPORTED_MODULE_2__/* .normalizeIdea */ .NA)(object);
            })
        };
    });
};


/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ObserverMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = ObserverMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    ObserverMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options) {
  if (options === void 0) {
    options = {};
  }

  if (!element) return function () {}; // An observer with the same options can be reused, so lets use this fact

  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      ObserverMap["delete"](id);
    }
  };
}

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    });
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        tag = _this$props2.tag,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView"]);

    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as || tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView;

  var unobserve = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      });
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (InView)));

//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 45363:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
__webpack_unused_export__ = ({ value: true });
exports.h6 = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var json_ld_1 = __webpack_require__(82342);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.helmetJsonLdProp; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.JsonLd; } });
Object.defineProperty(exports, "h6", ({ enumerable: true, get: function () { return json_ld_1.jsonLdScriptProps; } }));


/***/ }),

/***/ 82342:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.helmetJsonLdProp = exports.jsonLdScriptProps = exports.JsonLd = void 0;
const React = __webpack_require__(67294);
function JsonLd(props) {
    return React.createElement("script", Object.assign({}, jsonLdScriptProps(props.item, props)));
}
exports.JsonLd = JsonLd;
function jsonLdScriptProps(item, options = {}) {
    return {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(item, safeJsonLdReplacer, options.space),
        },
    };
}
exports.jsonLdScriptProps = jsonLdScriptProps;
function helmetJsonLdProp(item, options = {}) {
    return {
        type: "application/ld+json",
        innerHTML: JSON.stringify(item, safeJsonLdReplacer, options.space),
    };
}
exports.helmetJsonLdProp = helmetJsonLdProp;
const ESCAPE_ENTITIES = Object.freeze({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&apos;",
});
const ESCAPE_REGEX = new RegExp(`[${Object.keys(ESCAPE_ENTITIES).join("")}]`, "g");
const ESCAPE_REPLACER = (t) => ESCAPE_ENTITIES[t];
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */
const safeJsonLdReplacer = (() => {
    // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
    // Solution from https://stackoverflow.com/a/5499821/864313
    return (_, value) => {
        switch (typeof value) {
            case "object":
                // Omit null values.
                if (value === null) {
                    return undefined;
                }
                return value; // JSON.stringify will recursively call replacer.
            case "number":
            case "boolean":
            case "bigint":
                return value; // These values are not risky.
            case "string":
                return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
            default: {
                // We shouldn't expect other types.
                isNever(value);
                // JSON.stringify will remove this element.
                return undefined;
            }
        }
    };
})();
// Utility: Assert never
function isNever(_) { }


/***/ }),

/***/ 4022:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _classPrivateFieldGet; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_extract_field_descriptor.mjs
function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_apply_descriptor_get.mjs
function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_private_field_get.mjs



function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
  return _classApplyDescriptorGet(receiver, descriptor);
}


/***/ }),

/***/ 70222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _classPrivateFieldInit; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_check_private_redeclaration.mjs
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_private_field_init.mjs


function _classPrivateFieldInit(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

}]);